import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ExportService } from './layout/export-overlay/export-overlay.service';
import { ExportStoreService } from './layout/export-overlay/export-overlay.store';
import { UserService } from './core/user/user.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { User } from './core/user/user.types';
import { environment } from 'environments/environment.prod';
import { FuseAlertComponent } from '@fuse/components/alert';
import { PermissionBootstrapService } from './core/permission';
import { NavigationCacheService } from './core/navigation/navigation-cache.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, FuseAlertComponent],
    providers: [ExportService, ExportStoreService],
})
export class AppComponent {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private permissionsRestored = false;

    /**
     * Constructor
     */
    constructor(
        private _userService: UserService,
        private permissionsService: NgxPermissionsService,
        private permissionBootstrapService: PermissionBootstrapService,
        private navigationCacheService: NavigationCacheService
    ) {}

    ngOnInit(): void{
        this._userService.user$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((user: User) => {
            if(user == null) {
                this.permissionsRestored = false; // Reset flag cuando el usuario se desloguea
                return
            }

            // RBAC: restore cached permissions immediately, then refresh all pages from API
            if (this.permissionBootstrapService.isEnforcementEnabled && !this.permissionsRestored) {
                if (this.permissionBootstrapService.isLoginInProgress) {
                    return;
                }

                this.permissionBootstrapService.restorePermissionsFromStorage();
                this.permissionBootstrapService.refreshUserPermissions(user).pipe(
                    switchMap(() => this.navigationCacheService.refresh()),
                    takeUntil(this._unsubscribeAll),
                ).subscribe();
                this.permissionsRestored = true;
            }

            if(environment.hasPermission){
                this.permissionsService.flushPermissions();  // Limpia permisos de la librería

                let permissions = []
                try {
                    permissions = JSON.parse(localStorage.getItem('permissions'))
                    if(!Array.isArray(permissions))
                        permissions = []
                } catch (e) {}

                // Agregar permisos a la librería
                for (let permission of permissions)
                    this.permissionsService.addPermission(permission)
                }
        });
    }
}
